import { createSelector } from '@ngrx/store';

import { IAppState } from '../state/app.state';
import { ILoginState } from '../state/login.state';

const selectCurrentLogin = (state: IAppState) => state.curentLogin;


export const selectSelectedUser = createSelector(
    selectCurrentLogin,
  (state: ILoginState) => state.currentLogin
);
